export default import.meta.ROLLDOWN_FILE_URL_k$MyEWrLbG681yRwSJuz1w